import {Rows} from "Components/Layout/Table";

const DownloadConfigTable: Rows = {
    id: {
        placeholders: [
            {
                element: 'p',
                size: 1
            }
        ]
    },
    name: {
        field: 'name',
        translated: true,
        placeholders: [
            {
                element: 'p',
                size: [3],
            }
        ]
    },
    status: {
        field: 'status',
        translated: true,
        i18nKey: 'app.item_status.',
        placeholders: [
            {
                element: 'p',
                size: [2],
            }
        ]
    },
    actions: {
        className: 'actions',
        sortable: false,
        placeholders: [
            {
                element: 'a',
                size: 2,
            },
        ]
    },
};

export default DownloadConfigTable
